import { Controller } from 'stimulus';

// Editable "chips" over a comma-separated hidden input (dropdown options in the
// inline param editor). Existing values render as removable chips; an inline
// text input adds new ones on Enter / comma / blur. The hidden input stays the
// source of truth that submits AND that dropdown-options-sync reads, so the
// Default Value select keeps in sync. Old Stimulus 1.x target/action syntax.
export default class extends Controller {
  static targets = ['input', 'hidden'];

  connect() {
    this.values = this.parse(this.hiddenTarget.value);
    this.renderChips();
  }

  parse(str) {
    return (str || '').split(',').map((s) => s.trim()).filter((s) => s.length > 0);
  }

  add(event) {
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ',') return;
    if (event.type === 'keydown') event.preventDefault();

    const raw = (this.inputTarget.value || '').replace(/,/g, '').trim();
    this.inputTarget.value = '';
    if (raw && !this.values.includes(raw)) {
      this.values.push(raw);
      this.commit();
    }
  }

  // Delegated so dynamically-rendered chip buttons don't depend on per-element binding.
  onClick(event) {
    const btn = event.target.closest('[data-chip-remove]');
    if (!btn) return;
    event.preventDefault();

    const idx = parseInt(btn.dataset.chipRemove, 10);
    if (!Number.isNaN(idx)) {
      this.values.splice(idx, 1);
      this.commit();
    }
  }

  commit() {
    this.hiddenTarget.value = this.values.join(',');
    this.renderChips();
    // Let dropdown-options-sync rebuild the Default Value options.
    this.hiddenTarget.dispatchEvent(new Event('input', { bubbles: true }));
  }

  renderChips() {
    this.element.querySelectorAll('[data-chip]').forEach((el) => el.remove());

    this.values.forEach((val, i) => {
      const chip = document.createElement('span');
      chip.setAttribute('data-chip', '');
      chip.className = 'inline-flex items-center text-xs text-gray-700 bg-gray-100 rounded px-2 py-1';

      const label = document.createElement('span');
      label.textContent = val;
      chip.appendChild(label);

      const x = document.createElement('button');
      x.type = 'button';
      x.className = 'ml-1 text-gray-400 hover:text-gray-600 leading-none';
      x.textContent = '×';
      x.setAttribute('data-chip-remove', i);
      chip.appendChild(x);

      this.element.insertBefore(chip, this.inputTarget);
    });
  }
}
